module.exports = __webpack_public_path__ + "img/lens-174-minus-11.ded5e2e0.png";